// Utility function to format dates consistently without timezone conversion
const formatDate = (dateString) => {
    if (!dateString) return '-';

    // Split at T to get just the date portion of ISO string
    const [year, month, day] = dateString.split('T')[0].split('-');
    return `${month}/${day}/${year}`;
};

// Format date with time for comments
const formatDateTime = (dateString) => {
    if (!dateString) return '-';

    // Split the ISO string into date and time parts
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');

    // Get time without milliseconds and timezone
    const time = timePart.split('.')[0];

    return `${month}/${day}/${year} ${time}`;
};

// Convert from MM/DD/YYYY back to YYYY-MM-DD for form inputs
const parseFormDate = (displayDate) => {
    if (!displayDate) return '';
    const [month, day, year] = displayDate.split('/');
    return `${year}-${month}-${day}`;
};

export { formatDate, formatDateTime, parseFormDate };